import VueRouter, { NavigationGuardNext, Route, NavigationGuard } from "vue-router"
import store from "@/store"
import { DEFAULT_DOCUMENT_TITLE } from "./index"

export function setupGuards(router: VueRouter) {
    router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext) => {
        if (to.meta && to.meta.title) {
            store.commit("reduxi/setPageTitle", to.meta.title)
        }

        if (to.fullPath == "/") {
            store.commit("sidebar/setLastRootRoute", null)
        }

        const info = store.getters["reduxi/getSiteInfo"]
        const platformName = info?.platformName || DEFAULT_DOCUMENT_TITLE
        document.title = to.meta?.title ? `${to.meta.title} | ${platformName}` : platformName

        const requiresAuth = to.meta?.requiresAuth
        const requiredPermissions = to.meta?.permissions
        const user = store.getters["auth/user"]

        if (requiresAuth && requiredPermissions) {
            if (user) {
                if (requiredPermissions.includes(user.role)) {
                    next()
                } else {
                    next("/")
                }
            } else {
                next("/auth/login")
            }
        }

        next()
    })
}

export const navigationContextGuard: NavigationGuard = (to, from, next) => {
    if (from.meta?.isContextSource && to.meta?.maintainsContext) {
        store.dispatch("navigationContext/setNavigationContext", {
            sourceRoute: from.name,
            sourcePath: from.path,
            sourceTitle: from.meta.title,
            returnPath: from.path,
        })
    }

    if (to.meta?.isContextSource || (!to.meta?.maintainsContext && !from.meta?.isContextSource)) {
        store.dispatch("navigationContext/clearNavigationContext")
    }

    next()
}

export const roleCheckingGuard: NavigationGuard = (to, from, next) => {
    const user = store.getters["auth/user"]
    const userRole = user?.role

    if (to.path === "/" && userRole === "ROLE_SUPER_ADMIN") {
        next("/overview")
        return
    }

    next()
}
